import React from 'react'
import './FieldSet.scss'

interface FieldSetProps {
  children: React.ReactNode
  label: string
  required?: boolean
}
export const FieldSet: React.FC<FieldSetProps> = ({
  label,
  children,
  required,
}) => {
  return (
    <fieldset className={`fieldset${required ? ' fieldset--required' : ''}`}>
      <legend className="fieldset__legend">
        {required ? (
          <span className="fieldset__legend--required-asterisk">*</span>
        ) : null}
        {label}
      </legend>
      {children}
    </fieldset>
  )
}
